/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import {
  Button,
  Form,
  Dropdown,
  Divider,
  TextArea,
  Grid,
  Loader,
  Popup,
  Label
} from 'semantic-ui-react';
import _ from 'lodash';
import {
  insertAdPrototype,
  updateAdPrototype
} from '../../../services/AdPrototypeService';
import CallToAction from '../../../components/common/CallToAction';
import AdCarouselCard from './AdCarouselCard';
import AdBuilderAdPreviewModal from './AdBuilderAdPreviewModal';
import AdBuilderWarningModal from './AdBuilderWarningModal';
import { insertTag } from './../../../../src/services/TagService';

import './AdBuilderCarousel.css';

class AdBuilderCarousel extends Component {
  state = {
    selectedTags: {},
    errorMessage: '',
    successMessage: '',
    processing: false,
    campaigns: [],
    packages: [],
    form: {
      name: '',
      accountId: '',
      utm: '',
      message: '',
      callToAction: 'LEARN_MORE',
      cards: [
        {
          id:
            Math.random()
              .toString(36)
              .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15),
          headline: '',
          description: '',
          tile: '',
          tilePreview: ''
        }
      ],
      pageId: '1067945359908634' // constellation agency FB page ID
    },
    openTooManyVideosWarning: false,
    showAdBuilderAdPreviewModal: false,
    currentAdPrototype: {},
    qcApproved: null,
    isWarningModalOpen: false
  };

  componentDidMount() {
    const { adPrototypeEdit } = this.props;
    this.initializeTags();
    if (adPrototypeEdit) {
      this.initializeEdit(adPrototypeEdit);
    }
  }

  initializeTags = () => {
    if (this.props.tags) {
      this.setState({
        campaigns: this.getOptions(this.props.tags.campaign),
        packages: this.getOptions(this.props.tags.package)
      });
    }
  };

  initializeCard = () => {
    const id =
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15);
    return { id, headline: '', description: '', tile: '', tilePreview: '' };
  };

  initializeEdit = (adPrototypeEdit) => {
    const form = this.state.form;
    form.name = adPrototypeEdit.name;
    form.accountId = adPrototypeEdit.client;
    form.utm = adPrototypeEdit.utm;
    form.message = adPrototypeEdit.message;
    form.callToAction = adPrototypeEdit.call_to_action;
    const selectedTags = {
      corporate: [],
      oem: [],
      product: [],
      year: [],
      month: [],
      campaign: [],
      package: []
    };
    const cards = [];

    adPrototypeEdit.cards.forEach((card) =>
      cards.push({
        id: card.id,
        headline: card.headline,
        description: card.description,
        tilePreview: card.video ? card.video : card.thumbnail,
        tile: {
          video_thumbnail: card.thumbnail,
          facebook_asset_id: card.asset_id,
          tilePreview: card.video ? card.video : card.thumbnail
        }
      })
    );
    form.cards = cards;
    const countedVideoCards = this.countVideoCards(form);
    adPrototypeEdit.tags.map((tag) =>
      selectedTags[tag.category].push(tag.tag_id)
    );

    this.setState({
      form,
      selectedTags,
      openTooManyVideosWarning: countedVideoCards >= 5
    });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleCardChange = (event, { name, value }) => {
    const cardNumber = event.target.id - 1;
    const form = this.state.form;
    const card = form.cards[cardNumber];
    card[name] = value;
    form.cards[cardNumber] = card;
    this.setState({ ...this.state, form });
  };

  addCard = () => {
    const form = this.state.form;
    form.cards.push(this.initializeCard());
    this.setState({ form });
  };

  removeCard = (index) => {
    const form = this.state.form;
    form.cards.splice(index - 1, 1);
    this.setState({ form });
  };

  swapCard = (cardNumber, direction) => {
    const { form } = this.state;
    const prevElem = form.cards[cardNumber - 2];
    const currentElem = form.cards[cardNumber - 1];
    const nextElem = form.cards[cardNumber];

    if (direction === 'left') {
      form.cards[cardNumber - 1] = prevElem;
      form.cards[cardNumber - 2] = currentElem;
    } else {
      form.cards[cardNumber - 1] = nextElem;
      form.cards[cardNumber] = currentElem;
    }
    this.setState({ form });
  };

  onAccountSelect = (event, data) => {
    const account = _.find(
      data.options,
      (option) => option.value === data.value
    );
    const accountId = account.value;
    const form = this.state.form;
    form.accountId = accountId;

    this.setState({ form });
  };

  onSearchTagsSelect = (e, data) => {
    const { id: category, value: selectedSearchKeys, options } = data;

    const tags = options.filter(
      (option) => selectedSearchKeys.indexOf(option.key) !== -1
    );

    const tagOptionKeys = tags.map((tag) => tag.key);

    this.setState((prevState) => ({
      ...prevState,
      selectedTags: {
        ...prevState.selectedTags,
        [category]: tagOptionKeys
      }
    }));
  };

  onCallToActionSelect = (e, data) => {
    const call = _.find(data.options, (option) => option.value === data.value);

    const form = this.state.form;
    form.callToAction = call.value;

    this.setState({ form });
  };

  getOptions = (tags) => {
    if (!tags) {
      return [];
    }

    const options = tags.map((tag) => ({
      key: tag.id,
      value: tag.id,
      text: tag.value,
      category: tag.category
    }));

    return options;
  };

  getCards = () => {
    const stateCards = this.state.form.cards;
    const cards = [];
    stateCards.forEach((card, index) => {
      const { tile, tilePreview, headline, description } = card;
      const {
        video_thumbnail: videoThumbnail,
        facebook_asset_id: facebookAssetId
      } = tile;

      cards.push({
        name: '',
        headline,
        description,
        video: tilePreview.indexOf('.mp4') !== -1 ? tilePreview : null,
        thumbnail: tile && videoThumbnail ? videoThumbnail : tilePreview,
        asset_id: tile ? facebookAssetId : '',
        order: index + 1
      });
    });

    return cards;
  };

  getSelectedTags = () => {
    const selectedTags = this.state.selectedTags;
    let tags = [];

    if (selectedTags.corporate) {
      tags = tags.concat(selectedTags.corporate);
    }

    if (selectedTags.oem) {
      tags = tags.concat(selectedTags.oem);
    }

    if (selectedTags.product) {
      tags = tags.concat(selectedTags.product);
    }

    if (selectedTags.year) {
      tags = tags.concat(selectedTags.year);
    }

    if (selectedTags.month) {
      tags = tags.concat(selectedTags.month);
    }

    if (selectedTags.campaign) {
      tags = tags.concat(selectedTags.campaign);
    }

    if (selectedTags.package) {
      tags = tags.concat(selectedTags.package);
    }

    return tags;
  };

  saveAdPrototype = () => {
    const { adPrototypeEdit, searchPage, user } = this.props;
    const { qcApproved, form } = this.state;
    const { name, utm, message, accountId, callToAction } = form;

    this.setState(
      { errorMessage: '', successMessage: '', processing: true },
      async () => {
        const cards = this.getCards();

        const adPrototypeData = {
          name,
          utm,
          message,
          title: '',
          resource_id: null,
          type: 'Carousel',
          video: '',
          thumbnail: cards.length > 0 ? cards[0].thumbnail : '',
          client: accountId,
          tags: this.getSelectedTags(),
          asset_id: '',
          call_to_action: callToAction,
          cards,
          footerCopy: '',
          qc_approved:
            typeof qcApproved === 'boolean'
              ? qcApproved
              : adPrototypeEdit.qc_approved,
          created_by: user.email
        };

        if (adPrototypeEdit) {
          adPrototypeData.id = adPrototypeEdit.id;
        }

        const result = !adPrototypeEdit
          ? await insertAdPrototype(adPrototypeData)
          : await updateAdPrototype(adPrototypeData);

        if (result.statusCode === 200) {
          const successMessage = !adPrototypeEdit
            ? 'The Carousel Ad has been created'
            : 'The Carousel Ad has been updated';
          const { adPrototypeId } = result;
          adPrototypeData.id = adPrototypeId;
          this.setState(
            {
              successMessage,
              processing: false,
              currentAdPrototype: adPrototypeData
            },
            () => {
              if (!adPrototypeEdit && searchPage) {
                searchPage();
              }
            }
          );
        } else {
          this.setState({
            errorMessage: 'There was an error saving the Carousel Ad',
            processing: false
          });
        }
      }
    );
  };

  clearTags = () => {
    const form = this.state.form;
    form.accountId = '';
    this.setState({ selectedTags: {}, form });
  };

  onAddTag = (event, { category, value, options }) => {
    this.addTagOnceConfirmed({ category, value, options });
  };

  addTagOnceConfirmed = ({ category, value }) => {
    const { user } = this.props;

    const { email } = user || {};

    const isRequired =
      ['oem', 'type', 'year', 'product', 'language', 'condition'].indexOf(
        category
      ) > -1;

    const tag = {
      category,
      required: isRequired,
      value,
      created_by: email
    };

    insertTag(tag).then((result) => {
      const { statusCode, tag: addedTag } = result;

      if (statusCode === 200) {
        const { id } = addedTag || {};

        const newTagOption = {
          key: id,
          text: value,
          value: id,
          category
        };

        if (category === 'campaign') {
          const { campaigns } = this.state;
          campaigns.push(newTagOption);
          this.setState({ campaigns });
        } else if (category === 'package') {
          const { packages } = this.state;
          packages.push(newTagOption);
          this.setState({ packages });
        }
      }
    });
  };

  toggleTooManyVideoWarning = () => {
    const { openTooManyVideosWarning } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      openTooManyVideosWarning: !openTooManyVideosWarning
    }));
  };

  tooManyVideosWarningPopupStyle = (numberOfVideoCards) => {
    const style =
      numberOfVideoCards >= 5
        ? { color: 'red', opacity: 0.75 }
        : { color: 'black', opacity: 0.85 };
    return style;
  };

  countVideoCards = (form) => {
    const { cards } = form;
    let videoCounter = 0;
    cards.forEach((card) => {
      const { tile } = card;
      if (tile) {
        const { type } = tile;
        if (type && type.indexOf('video') !== -1) {
          videoCounter = videoCounter + 1;
        }
      }
    });
    return videoCounter;
  };

  toggleAdBuilderAdPreviewModal = () => {
    const { showAdBuilderAdPreviewModal } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      showAdBuilderAdPreviewModal: !showAdBuilderAdPreviewModal
    }));
  };

  updateAdPrototypeForQc = (qcBool) => {
    this.setState((prevState) => ({
      ...prevState,
      qcApproved: qcBool
    }));
  };

  toggleWarningModal = () => {
    const { isWarningModalOpen } = this.state;
    this.setState({ ...this.state, isWarningModalOpen: !isWarningModalOpen });
  };

  render() {
    const {
      selectedTags,
      processing,
      errorMessage,
      successMessage,
      form,
      campaigns,
      packages,
      openTooManyVideosWarning,
      showAdBuilderAdPreviewModal,
      currentAdPrototype,
      qcApproved: qcApprovedState,
      isWarningModalOpen
    } = this.state;
    const {
      tags,
      accounts,
      searchPage,
      getFbToken,
      adPrototypeEdit
    } = this.props;
    const { name, accountId, utm, message, callToAction, cards, pageId } = form;
    const modalFields = { name, message, callToAction, cards };
    const missingFieldKeys = Object.keys(modalFields).filter((key) => {
      if (key === 'cards') {
        const inValidCards = form[key].filter((card) => {
          return !card.headline || !card.description || !card.tile;
        });
        return inValidCards.length > 0 || cards.length < 2;
      }
      return !form[key];
    });
    const numberOfVideoCards = this.countVideoCards(form);
    const adPrototypeForPreview = currentAdPrototype.id
      ? currentAdPrototype
      : adPrototypeEdit;
    const { qc_approved: qcApprovedProp } = adPrototypeForPreview || {};
    const qcApproved =
      typeof qcApprovedState === 'boolean' ? qcApprovedState : qcApprovedProp;
    return (
      <div>
        {processing ? (
          <div>
            <span>
              <Loader inline className="active" />
              Processing...
            </span>
          </div>
        ) : null}
        <div className="carousel-builder-message-container">
          {errorMessage ? (
            <div>
              <span className="carousel-builder-error">{errorMessage}</span>
            </div>
          ) : null}
          {successMessage ? (
            <div>
              <span className="carousel-builder-message">{successMessage}</span>
            </div>
          ) : null}
        </div>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={4}>
              <Button onClick={searchPage} size="small" color="grey">
                Back
              </Button>
              <Button
                onClick={() => {
                  if (missingFieldKeys.length > 0) {
                    this.toggleWarningModal();
                  } else {
                    this.saveAdPrototype();
                  }
                }}
                size="small"
                color="blue"
              >
                Save
              </Button>
              <h1>{!adPrototypeEdit && 'NEW '} CAROUSEL AD</h1>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Form.Input
                      placeholder="Name"
                      type="text"
                      name="name"
                      value={name}
                      onChange={this.handleFormChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      onClick={this.clearTags}
                      className="carousel-builder-tag-button"
                      size="small"
                      color="green"
                    >
                      Clear Tags
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider hidden />
              <Dropdown
                placeholder="Model/Product"
                search
                multiple
                selection
                allowAdditions
                id="product"
                category="product"
                value={selectedTags.product ? selectedTags.product : []}
                className="carousel-builder-multiple-tags"
                options={this.getOptions(tags.product)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Year"
                search
                multiple
                selection
                allowAdditions
                id="year"
                category="year"
                value={selectedTags.year ? selectedTags.year : []}
                className="carousel-builder-multiple-tags"
                options={this.getOptions(tags.year)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="OEM"
                search
                multiple
                selection
                allowAdditions
                id="oem"
                category="oem"
                value={selectedTags.oem ? selectedTags.oem : []}
                className="carousel-builder-multiple-tags"
                options={this.getOptions(tags.oem)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Client"
                search
                selection
                value={accountId}
                options={accounts}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Campaign"
                search
                multiple
                selection
                allowAdditions
                id="campaign"
                category="campaign"
                value={selectedTags.campaign ? selectedTags.campaign : []}
                className="canvas-builder-multiple-tags"
                options={campaigns}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Campaign Month"
                search
                multiple
                selection
                allowAdditions
                id="month"
                category="month"
                value={selectedTags.month ? selectedTags.month : []}
                className="canvas-builder-multiple-tags"
                options={this.getOptions(tags.month)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Package"
                search
                multiple
                selection
                allowAdditions
                id="package"
                category="package"
                value={selectedTags.package ? selectedTags.package : []}
                className="canvas-builder-multiple-tags"
                options={packages}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Corporate Target"
                search
                multiple
                selection
                allowAdditions
                id="corporate"
                category="corporate"
                value={selectedTags.corporate ? selectedTags.corporate : []}
                className="carousel-builder-multiple-tags"
                options={this.getOptions(tags.corporate)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Divider hidden />
              <TextArea
                className="carousel-builder-textarea-utm"
                placeholder="UTM Code"
                name="utm"
                rows="5"
                value={utm}
                onChange={this.handleFormChange}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              <TextArea
                className="carousel-builder-textarea"
                placeholder="Text"
                name="message"
                rows="5"
                value={message}
                onChange={this.handleFormChange}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Call To Action"
                search
                selection
                id="callToAction"
                value={callToAction}
                options={CallToAction}
                onChange={this.onCallToActionSelect}
              />
              <Divider hidden />
              <Popup
                style={this.tooManyVideosWarningPopupStyle(numberOfVideoCards)}
                position="right center"
                content={`Because of the current limitations of the FB API, it is recommended that there be only 
                            5 videos MAXIMUM in a carousel ad. Otherwise, the ad will likely not launch, either by
                            itself or in a package.`}
                trigger={
                  <Button
                    color={numberOfVideoCards >= 5 ? 'red' : ''}
                    icon="info circle"
                    onClick={this.toggleTooManyVideoWarning}
                  />
                }
                open={openTooManyVideosWarning}
              />
              <Divider hidden />
              <Button
                disabled={!adPrototypeForPreview}
                color="facebook"
                onClick={this.toggleAdBuilderAdPreviewModal}
              >
                View Ad Preview
              </Button>
              <Divider hidden />
              {typeof qcApproved === 'boolean' ? (
                <Label
                  size="large"
                  color={qcApproved ? 'green' : 'red'}
                  content={`QC: ${qcApproved ? 'Approved' : 'Denied'}`}
                />
              ) : (
                <Label color="grey" content="QC: No status" />
              )}
              <AdBuilderAdPreviewModal
                showAdBuilderAdPreviewModal={showAdBuilderAdPreviewModal}
                toggleAdBuilderAdPreviewModal={
                  this.toggleAdBuilderAdPreviewModal
                }
                adPrototypeEdit={adPrototypeForPreview}
                adType={'Carousel'}
                pageId={pageId}
                getFbToken={getFbToken}
                updateAdPrototypeForQc={this.updateAdPrototypeForQc}
                inEditor
              />
              <AdBuilderWarningModal
                formKeys={missingFieldKeys}
                isWarningModalOpen={isWarningModalOpen}
                toggleWarningModal={this.toggleWarningModal}
                saveAdPrototype={() => {
                  this.setState(
                    { ...this.state, isWarningModalOpen: false },
                    () => {
                      this.saveAdPrototype();
                    }
                  );
                }}
              />
              <Divider hidden />
              <Grid>
                <Grid.Row columns={5}>
                  {cards.slice(0, 5).map((card, index) => (
                    <Grid.Column>
                      <AdCarouselCard
                        card={card}
                        totalCards={cards.length}
                        editId={card.id}
                        key={card.id}
                        swapCard={this.swapCard}
                        edit={adPrototypeEdit !== ''}
                        cardNumber={index + 1}
                        handleCardChange={this.handleCardChange}
                        removeCard={this.removeCard}
                        getFbToken={getFbToken}
                        tilePreviewProp={card.tilePreview}
                      />
                    </Grid.Column>
                  ))}
                  {cards.length < 5 ? (
                    <Grid.Column>
                      <AdCarouselCard
                        addCard={this.addCard}
                        getFbToken={getFbToken}
                      />
                    </Grid.Column>
                  ) : null}
                </Grid.Row>
                <Grid.Row columns={5}>
                  {cards.length > 5
                    ? cards.slice(5).map((card, index) => (
                        <Grid.Column>
                          <AdCarouselCard
                            card={card}
                            totalCards={cards.length}
                            swapCard={this.swapCard}
                            editId={card.id}
                            key={card.id}
                            edit={adPrototypeEdit !== ''}
                            cardNumber={index + 6}
                            handleCardChange={this.handleCardChange}
                            removeCard={this.removeCard}
                            getFbToken={getFbToken}
                            tilePreviewProp={card.tilePreview}
                          />
                        </Grid.Column>
                      ))
                    : null}
                  {cards.length >= 5 && cards.length < 10 ? (
                    <Grid.Column>
                      <AdCarouselCard
                        addCard={this.addCard}
                        getFbToken={getFbToken}
                      />
                    </Grid.Column>
                  ) : null}
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default AdBuilderCarousel;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderCarousel.js